import { Link } from "react-router-dom";

const NAV = [
  { to: "/science", label: "SCIENCE" },
  { to: "/programmes", label: "PROGRAMMES" },
  { to: "/products", label: "PRODUCTS" },
  { to: "/technology", label: "TECHNOLOGY" },
  { to: "/thinking", label: "THINKING" },
  { to: "/about", label: "ABOUT" },
  { to: "/founder", label: "FOUNDER" },
  { to: "/contact", label: "CONTACT" },
];

const LEGAL = [
  { to: "/privacy", label: "PRIVACY" },
  { to: "/terms", label: "TERMS" },
  { to: "/disclaimer", label: "DISCLAIMER" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-[#1f1e1a] bg-[#070706]">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr_1.6fr]">
          <div>
            <p className="font-display text-2xl font-extrabold tracking-[0.25em] text-[#f5f2ea]">
              W8ED
            </p>
            <p className="mt-3 font-mono text-[10px] tracking-[0.3em] text-[#C9A227]">
              DISCIPLINE &gt; DOPAMINE
            </p>
          </div>

          <nav aria-label="Footer navigation">
            <p className="mb-4 font-mono text-[9px] tracking-[0.3em] text-[#57534a]">SITE</p>
            <ul className="space-y-2.5">
              {NAV.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="font-mono text-[10px] tracking-[0.2em] text-[#8e8a80] transition-colors hover:text-[#f5f2ea]"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="Legal">
            <p className="mb-4 font-mono text-[9px] tracking-[0.3em] text-[#57534a]">LEGAL</p>
            <ul className="space-y-2.5">
              {LEGAL.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="font-mono text-[10px] tracking-[0.2em] text-[#8e8a80] transition-colors hover:text-[#f5f2ea]"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <p className="mb-4 font-mono text-[9px] tracking-[0.3em] text-[#57534a]">COMPANY</p>
            <address className="space-y-1.5 font-mono text-[10px] not-italic leading-relaxed tracking-[0.1em] text-[#8e8a80]">
              <p className="text-[#b8b3a6]">W8ED PRIVATE LIMITED</p>
              <p>CIN: U62099KA2026PTC227613</p>
              <p>WeWork – 37 Cunningham</p>
              <p>Cunningham Road, No. 37, Cunningham Cross Road</p>
              <p>SRT Road, Vasanth Nagar</p>
              <p>Bengaluru, Karnataka 560052</p>
              <p>India</p>
              <p className="pt-2">
                <a href="mailto:support@w8ed.com" className="transition-colors hover:text-[#f5f2ea]">
                  support@w8ed.com
                </a>
              </p>
              <p>
                <a href="tel:+917483549690" className="transition-colors hover:text-[#f5f2ea]">
                  7483549690
                </a>
              </p>
              <p>www.w8ed.com</p>
            </address>
          </div>
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-between gap-4 border-t border-[#1f1e1a] pt-8">
          <p className="font-mono text-[9px] tracking-[0.25em] text-[#57534a]">
            © 2026 W8ED PRIVATE LIMITED. ALL RIGHTS RESERVED.
          </p>
          <p className="font-mono text-[9px] tracking-[0.25em] text-[#57534a]">
            YOU ARE WHAT YOU REPEAT.
          </p>
        </div>
      </div>
    </footer>
  );
}
